import React from 'react';
import ResponsiveWrapper from '../../../components/ResponsiveWrapper';
import OrganizationManagement from './index';
import MobileOrganizationManagement from './MobileOrganizationManagement';

const ResponsiveOrganizationManagement = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileOrganizationManagement />}
      desktop={<OrganizationManagement />}
    />
  );
};

export default ResponsiveOrganizationManagement;